import React, { useEffect } from 'react';

function ContactPage() {
  
  // This will set the browser tab title
  useEffect(() => {
    document.title = "Contact - TechPack Creators";
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-purple-100 pt-24">
      <h2 className="text-3xl font-bold mb-6 font-montserrat">Get in Touch</h2>
      <form 
        action="https://formspree.io/f/mblpnepy" 
        method="POST" 
        className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full"
      >
        <input 
          type="text" 
          name="name" 
          placeholder="Your Name" 
          className="w-full p-3 mb-4 border rounded-lg font-montserrat" 
          required 
        />
        <input 
          type="email" 
          name="email" 
          placeholder="Your Email" 
          className="w-full p-3 mb-4 border rounded-lg font-montserrat" 
          required 
        />
        <input 
          type="tel" 
          name="phone" 
          placeholder="Your Contact/WhatsApp Number" 
          className="w-full p-3 mb-4 border rounded-lg font-montserrat" 
        />
        <textarea 
          name="message" 
          placeholder="Your Message" 
          className="w-full p-3 mb-4 border rounded-lg font-montserrat" 
          rows="4" 
        />
        <div className="text-center">
          <button 
            type="submit" 
            className="px-6 py-3 bg-yellow-800 text-white rounded-lg shadow-lg hover:bg-yellow-900 transition font-montserrat"
          >
            Send Message
          </button>
        </div>
      </form>
    </div>
  );
}

export default ContactPage;